module.exports = __webpack_public_path__ + "static/media/nitr+cld2.3aa70c58.png";